const PaymentLinkTransactions = () => {
	return <div>PaymentLinkTransactions</div>;
};

export default PaymentLinkTransactions;
